import axios from 'axios';
import ServerProperties from '../config/server.js'

export default {
  Read: function(params) {
    axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
    axios.get(
      ServerProperties.ATM_CLOUD.API+'Booking/Reservation/Read/?status=' + params.data.status+ '&' + params.data.order + '&' + params.data.filter + '&page=' + params.data.page,
      params.data
    )
    .then(function (response) {
      params.onsuccess(params, response);
    })
    .catch(error => {
      params.onfailed(params, error)
    });
  }
}



// WEBPACK FOOTER //
// ./src/App/booking/model.js